import PropTypes from "prop-types";
import React from 'react';
import { Label } from 'reactstrap';

const ErrorMessage = ({ message, danger=false }) =>{
  return (
    <>
      {
        (message !== '') ?
        (
          <Label style={{ 
            color: 'white', 
            fontStyle: 'italic', 
            marginBottom: 15 , 
            width: danger ? '100%' : '', 
            border: danger ? '1px solid red' : '',
            padding: danger ? '0.25em' : '',
            borderRadius: danger ? '5px' : '',
            backgroundColor: danger ? '#A71D2A' : ''
          }}>
            {message}
          </Label>
        )
        : (
          <></>
        )
      }
    </>
  )
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
  danger: PropTypes.bool
}

ErrorMessage.defaultProps = {
  danger: false
}

export default ErrorMessage
